module.exports = __webpack_public_path__ + "static/fonts/Fact-BlackItalic.45cd2a4.woff2";